import { VFC } from 'react';
import { Badge } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons/lib/icons';
import { LAST_20_DAYS } from 'consts/common';
import { FormattedMessage } from 'react-intl';
import { theme } from '../../../../../consts/themeBase';
import { FullWidthHeightSpace } from '../../../../../components/Space/FullWidthHeightSpace';
import { ContentSensorNotResponding as messages } from '../messages';

export const ContentSensorNotResponding: VFC = () => (
  <FullWidthHeightSpace direction="vertical">
    <div className="text-center">
      <ExclamationCircleOutlined style={{ color: theme.colors.warningYellow, fontSize: 100 }} />
    </div>
    <Badge status="success" text={<FormattedMessage {...messages.success} />} />
    <Badge status="warning" text={<FormattedMessage {...messages.warning} values={{ days: LAST_20_DAYS }} />} />
  </FullWidthHeightSpace>
);
